import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Spinner, Text } from '@shopify/polaris';
import { Layout } from '../components/Layout';

/**
 * Callback page for GA4 account provisioning.
 * Google redirects here after the user accepts ToS.
 * Reads siteId from localStorage and redirects to the Setup page
 * with the accountTicketId so it can poll for the new account.
 */
export function ProvisionCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const accountTicketId = searchParams.get('accountTicketId');
    const accountId = searchParams.get('accountId');
    const siteId = localStorage.getItem('provision_site_id');

    // Clean up localStorage
    localStorage.removeItem('provision_site_id');

    if (siteId) {
      const params = new URLSearchParams();
      if (accountTicketId) params.set('accountTicketId', accountTicketId);
      else if (accountId) params.set('accountId', accountId);

      const query = params.toString() ? `?${params.toString()}` : '';
      navigate(`/site/${siteId}/setup${query}`, { replace: true });
    } else {
      // No siteId found - redirect to dashboard
      navigate('/dashboard', { replace: true });
    }
  }, [searchParams, navigate]);

  return (
    <Layout>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '60px', gap: '16px' }}>
        <Spinner size="large" />
        <Text as="p" tone="subdued">Setting up your GA4 account...</Text>
      </div>
    </Layout>
  );
}
